import actions from '../../constants/actions';

export const login = (username, password) => {
  return {
    type: actions.LOGIN,
    payload: {
      username,
      password
    }
  };
};

export const logout = () => {
  return {
    type: actions.LOGOUT
  };
};

export const getUserMe = () => {
  return {
    type: actions.LOAD_USER_ME
  };
};



// WEBPACK FOOTER //
// ./src/redux/actions/auth.js